import { useEffect, useMemo, useRef, useState } from "react";
import { IFInitWalletRsp } from "@/api/apiRsp/IFWalletRsp";
import type { FormInstance } from "@/componentsUI/Form";
import { sys } from "@/Core/utils/system";

export function useRechargeCurrency(wallets: IFInitWalletRsp[] | undefined, form: FormInstance) {
  const [selectedCurrency, setSelectedCurrency] = useState<string>();
  const wallet = wallets?.find((item) => item.currencyType === selectedCurrency) || wallets?.[0];
  const displayCurrencyType = wallet?.currencyType;
  const serverCurrencyType = wallet?.serverCurrencyType || displayCurrencyType;
  const previousCurrency = useRef(displayCurrencyType);
  const params = useMemo(() => serverCurrencyType ? {
    currencyType: serverCurrencyType,
    device: sys.device,
  } : undefined, [serverCurrencyType]);

  useEffect(() => {
    setSelectedCurrency(displayCurrencyType);
    form.setFieldValue("walletType", displayCurrencyType);
    if (previousCurrency.current !== displayCurrencyType) {
      form.setFieldValue("amount", undefined);
      form.setFieldValue("payType", undefined);
    }
    previousCurrency.current = displayCurrencyType;
  }, [displayCurrencyType, form]);

  const changeRecharge = (index: number) => {
    const next = wallets?.[index];
    if (next) setSelectedCurrency(next.currencyType);
  };

  return { params, displayCurrencyType, changeRecharge };
}
